
  <!-- <app-header></app-header> -->

  <main [ngStyle]="{'background-color' : this.mapService.configurationService.currentConfiguration?.display.mapBackground }">

    <div class="wrapper" id="map" [ngClass]="this.toolsService.navigationOnTop? 'top' : ''"></div>
    <div id="popup" class="ol-popup" [ngStyle]="{'display' : this.mapService.identifyToolEnabled ? '' : 'none' }">
      <a href="#" id="popup-closer" class="ol-popup-closer"></a>
      <div id="popup-content" class="popup-content"></div>
    </div>
    <div class="sticky-menu">
      <app-menu (menuStateChange)="updateWatermarkPositionHorizontal()"></app-menu>
      <img class="sticky-menu__bottom sticky-menu__bottom--app" src="/assets/img/logo.png" alt="eurocontrol logo" />
    </div>
    <app-footer (footerStateChange)="updateWatermarkPositionVertical()"></app-footer>
    <app-add-sectorizations></app-add-sectorizations>
    <app-add-navaid-angles></app-add-navaid-angles>
    <!-- <app-coordenates-control></app-coordenates-control> -->
    <app-search-control></app-search-control>
    <app-shortcuts></app-shortcuts>
    <app-global-selection></app-global-selection>
    <app-support-ticket-shortcut></app-support-ticket-shortcut>
    <app-scale-control></app-scale-control>
    <!--<app-distance-azimuth></app-distance-azimuth>-->
    <app-terrain-height></app-terrain-height>
    <!-- <footer class="footer" [ngClass]="[toolsService.navigationOnTop? 'top' : '', tabsService.minimizeScreenMode ? 'bottom-menu minimized' : '']"> -->
    <footer
      class="map-coordinates-footer"
      [ngClass]="{
        'top': toolsService.navigationOnTop,
        'events-open': displayCloseEventsButton()      }">
      <div>
        <div>
          <span title="Position of mouse in map coordinates"> {{ this.mapService.coordinates }} </span> <span>{{this.mapService.latitude}}</span> <span>{{this.mapService.longitude }}</span>
        </div>
      </div>
    </footer>
    <app-terrain-watermark class="terrain-watermark-footer" *ngIf="showWatermark"></app-terrain-watermark>
  </main>


